import { motion } from 'framer-motion';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';

export default function AboutPage() {
  return (
    <div className="min-h-screen flex flex-col">
      <div className="noise-overlay" />
      <Navbar />
      
      <main className="flex-1">
        <section className="container mx-auto px-6 md:px-12 lg:px-24 py-16 md:py-24">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="max-w-3xl mx-auto"
          >
            <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight mb-8 text-center">
              About <em className="font-semibold">AIDreamSpaces</em>
            </h1>
            
            <div className="space-y-6 text-muted-foreground leading-relaxed">
              <motion.p
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.2 }}
                className="text-lg"
              >
                Welcome to AIDreamSpaces — a digital gallery where artificial intelligence 
                meets artistic vision. This collection showcases the breathtaking possibilities 
                that emerge when cutting-edge AI technology is guided by creative intent.
              </motion.p>

              <motion.p
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.3 }}
              >
                Each image in this gallery represents a unique collaboration between human 
                imagination and machine learning. Through careful prompting and curation, 
                these works explore the boundaries of digital art — from surreal dreamscapes 
                to abstract compositions that challenge our perception of reality.
              </motion.p>

              <motion.p
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.4 }}
              >
                The name "AIDreamSpaces" reflects the ethereal, often otherworldly nature 
                of AI-generated imagery. Like dreams, these creations exist in a space 
                between the familiar and the fantastic, inviting viewers to explore 
                landscapes and forms that have never existed before.
              </motion.p>

              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.5 }}
                className="pt-8 border-t border-border"
              >
                <h2 className="font-heading text-2xl font-semibold text-foreground mb-4">
                  The Vision
                </h2>
                <p>
                  This gallery serves as both a showcase and an exploration of what's 
                  possible when we embrace AI as a creative tool. Every piece here is 
                  selected not just for its aesthetic appeal, but for its ability to 
                  evoke emotion, spark imagination, and demonstrate the artistic 
                  potential of artificial intelligence.
                </p>
              </motion.div>

              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.6 }}
                className="pt-8 border-t border-border"
              >
                <h2 className="font-heading text-2xl font-semibold text-foreground mb-4">
                  Categories
                </h2>
                <ul className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
                  {['Abstract', 'Surrealism', 'Dreamscapes', 'Cyberpunk', 'Nature', 'Portraits', 'Architecture', 'Sci-Fi'].map((category, index) => (
                    <motion.li
                      key={category}
                      initial={{ opacity: 0, x: -10 }}
                      animate={{ opacity: 1, x: 0 }}
                      transition={{ delay: 0.7 + index * 0.05 }}
                      className="flex items-center space-x-2"
                    >
                      <span className="w-2 h-2 rounded-full bg-primary" />
                      <span>{category}</span>
                    </motion.li>
                  ))}
                </ul>
              </motion.div>
            </div>
          </motion.div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
